// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1NZn7","error":"Textarea_error__3Avck","readonly":"Textarea_readonly__i8peq","disabled":"Textarea_disabled__G_Bo1"};